/* ============================================================================
   ATHLO+ — Save to Locker (universal favourites)
   ----------------------------------------------------------------------------
   Zero-backend personalisation: lets visitors ♥ any club / venue / race /
   expert and collect them in The Locker. Stored in localStorage (key
   'hub:saves'), synced live across the page via a 'hub:saves' window event.
   This is a RETENTION + sign-up driver — value is the visitor's own collection,
   no content is gated. (Signed-in sync across devices is the optional upsell.)

   API: window.HubSave
     .all()            -> [{id,type,name,sub,url,ts}]
     .has(id)          -> bool
     .count()          -> number
     .get(id)          -> item | null
     .toggle(item)     -> bool (true if now saved)   item = {id,type,name,sub,url}
     .remove(id)
     .on(fn)           -> unsubscribe   (fn receives the list on every change)
     .button(item)     -> a wired <button> ♥ toggle you can append to a card
   `id` must be globally unique, e.g. 'club:sgrc' or 'hub_venue:kallang-pool'.
   ========================================================================== */
(function () {
  'use strict';
  var KEY = 'hub:saves';

  function read() { try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  var subs = [];
  function emit(a) {
    a = a || read();
    subs.forEach(function (f) { try { f(a); } catch (e) {} });
    try { window.dispatchEvent(new CustomEvent('hub:saves', { detail: { list: a, count: a.length } })); } catch (e) {}
    document.querySelectorAll('[data-hub-save-count]').forEach(function (n) { n.textContent = a.length; n.setAttribute('data-empty', a.length ? 'false' : 'true'); });
    document.querySelectorAll('[data-hub-saved-link]').forEach(function (n) { if (a.length) n.removeAttribute('hidden'); else n.setAttribute('hidden', ''); });
  }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} emit(a); }
  function has(id) { return read().some(function (x) { return x.id === id; }); }
  function toggle(item) {
    var a = read(), i = -1;
    for (var k = 0; k < a.length; k++) { if (a[k].id === item.id) { i = k; break; } }
    if (i > -1) { a.splice(i, 1); write(a); return false; }
    a.unshift({ id: item.id, type: item.type || '', name: item.name || '', sub: item.sub || '', url: item.url || '', ts: Date.now() });
    write(a); return true;
  }
  function remove(id) { write(read().filter(function (x) { return x.id !== id; })); }
  function on(cb) { subs.push(cb); return function () { var i = subs.indexOf(cb); if (i > -1) subs.splice(i, 1); }; }

  var SVG = '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path d="M12 20.5S4 16 1.7 11.3C.4 8.7 1.6 5.3 4.9 5.3c2 0 3.2 1.2 4 2.4C9.7 6.5 10.9 5.3 12.9 5.3c3.3 0 4.5 3.4 3.2 6C13.8 16 12 20.5 12 20.5z"/></svg>';
  function button(item, opts) {
    opts = opts || {};
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'hub-save-btn' + (opts.cls ? ' ' + opts.cls : '');
    function paint() {
      var onState = has(item.id);
      b.setAttribute('aria-pressed', onState ? 'true' : 'false');
      b.classList.toggle('is-on', onState);
      b.title = onState ? 'Saved to your locker' : 'Save to your locker';
      b.setAttribute('aria-label', (onState ? 'Remove ' : 'Save ') + (item.name || 'item') + (onState ? ' from' : ' to') + ' your locker');
      b.innerHTML = SVG + '<span class="hub-save-btn__t">' + (onState ? 'Saved' : 'Save') + '</span>';
    }
    b.addEventListener('mousedown', function (e) { e.stopPropagation(); });
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      // Save is a member perk — non-members get the Join modal instead.
      if (window.HubMember && !window.HubMember.is()) { window.HubMember.openJoin('save'); return; }
      var nowOn = toggle(item); paint();
      if (typeof window.gtag === 'function') window.gtag('event', 'hub_save', { id: item.id, type: item.type, saved: nowOn });
      if (window.dataLayer && window.dataLayer.push) window.dataLayer.push({ event: 'hub_save', save_id: item.id, save_type: item.type, saved: nowOn });
    });
    on(function () { paint(); });
    paint();
    return b;
  }

  if (!document.getElementById('hub-save-css')) {
    var s = document.createElement('style'); s.id = 'hub-save-css';
    s.textContent = '.hub-save-btn{display:inline-flex;align-items:center;gap:.4em;margin-top:.9rem;font:600 .72rem/1 var(--font-mono,monospace);letter-spacing:.05em;text-transform:uppercase;color:var(--muted,#aaa);background:transparent;border:1px solid var(--line,rgba(255,255,255,.16));border-radius:999px;padding:.5em .85em;cursor:pointer;transition:color .18s,border-color .18s,background .18s}.hub-save-btn:hover{color:var(--fg,#fff);border-color:var(--fg,#fff)}.hub-save-btn svg{fill:none;stroke:currentColor;stroke-width:1.8}.hub-save-btn.is-on{color:var(--lime,#B7FF00);border-color:var(--lime,#B7FF00);background:color-mix(in srgb,var(--lime,#B7FF00) 12%,transparent)}.hub-save-btn.is-on svg{fill:currentColor;stroke:currentColor}';
    (document.head || document.documentElement).appendChild(s);
  }

  window.HubSave = {
    KEY: KEY, all: read, has: has, count: function () { return read().length; },
    get: function (id) { return read().filter(function (x) { return x.id === id; })[0] || null; },
    toggle: toggle, remove: remove, on: on, button: button
  };

  /* === ADDON: product-card ♡ buttons =======================================
     snippets/hub-product-card.liquid renders a `[data-hub-save]` heart on every
     product card (collections, search) but NOTHING listened for it — the button
     was inert on click and the header's saved counter never left 0. Delegated so
     it also covers cards injected after load. Removable: delete this block.
     ====================================================================== */
  function saveIdOf(btn) { var raw = btn.getAttribute('data-hub-save'); return raw ? 'product:' + raw : ''; }
  function itemFor(btn) {
    var id = saveIdOf(btn); if (!id) return null;
    var card = (btn.closest && btn.closest('article, .product')) || document;
    var link = card.querySelector && card.querySelector('a[href*="/products/"]');
    var nameEl = card.querySelector && card.querySelector('.product__name');
    var priceEl = card.querySelector && card.querySelector('.product__price');
    return {
      id: id, type: 'Product',
      name: btn.getAttribute('data-hub-save-title') || (nameEl && nameEl.textContent.trim()) || 'Product',
      sub: (priceEl && priceEl.textContent.trim()) || '',
      url: link ? String(link.getAttribute('href') || '').split('?')[0] : ''
    };
  }
  function paintSaveBtn(btn) {
    var onState = has(saveIdOf(btn));
    btn.classList.toggle('is-on', onState);
    btn.classList.toggle('saved', onState); // the-hub.css styles the filled state as .product__save.saved
    btn.setAttribute('aria-pressed', onState ? 'true' : 'false');
    var t = btn.getAttribute('data-hub-save-title') || 'item';
    btn.setAttribute('aria-label', (onState ? 'Remove ' : 'Save ') + t + (onState ? ' from' : ' to') + ' your locker');
  }
  function paintAllSaveBtns() { document.querySelectorAll('[data-hub-save]').forEach(paintSaveBtn); }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-hub-save]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    // Same member gate as HubSave.button().
    if (window.HubMember && !window.HubMember.is()) { window.HubMember.openJoin('save'); return; }
    var item = itemFor(btn); if (!item) return;
    var nowOn = toggle(item);
    paintSaveBtn(btn);
    if (typeof window.gtag === 'function') window.gtag('event', 'hub_save', { id: item.id, type: item.type, saved: nowOn });
    if (window.dataLayer && window.dataLayer.push) window.dataLayer.push({ event: 'hub_save', save_id: item.id, save_type: item.type, saved: nowOn });
  });
  on(paintAllSaveBtns);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paintAllSaveBtns);
  else paintAllSaveBtns();
  document.addEventListener('shopify:section:load', paintAllSaveBtns);

  emit();
})();
